import { Society } from "./society.model";

export class Famille {
  id: number;
  name: string;
  observation: string;
  categorie: string;
  society: Society;

  constructor() {
    this.society = new Society();
  }
}

export class FamilleForm {
  id: number;
  name: string;
  observation: string;
  categorie: string;
  society: number;

  constructor() {}
}
